import { render, staticRenderFns } from "./AccountSettingNotificationSetting.vue?vue&type=template&id=0346e943"
import script from "./AccountSettingNotificationSetting.vue?vue&type=script&lang=js"
export * from "./AccountSettingNotificationSetting.vue?vue&type=script&lang=js"
import style0 from "./AccountSettingNotificationSetting.vue?vue&type=style&index=0&id=0346e943&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports